<template>
  <text-input :label="label" :show-label="showLabel" :input-name="calculatedInputName" :input-id="calculatedInputId"
              :value="value" :required="required" :min-length="minLength" :max-length="maxLength"
              :autocomplete="autocomplete" :validation-errors="validationErrors" @changed="changed" @focus="$emit('focus')" />
</template>

<script>
import kebabCase from 'lodash/kebabCase'
import snakeCase from 'lodash/snakeCase'
import TextFieldMixin from './mixins/text-field-mixin'

export default {
  mixins: [ TextFieldMixin ],

  props: {
    autocompleteType: {
      type: String,
      required: true
    },

    labelOverride: {
      type: String,
      required: false,
      default: null
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    type: {
      type: String,
      required: true
    }
  },

  emits: ['focus'],

  computed: {
    autocomplete() {
      return `${this.autocompleteType}-name`
    },

    calculatedInputId() {
      if (this.inputId) {
        return this.inputId
      }

      return `${this.entityName}-${kebabCase(this.type)}-name-field`
    },

    calculatedInputName() {
      if (this.inputName) {
        return this.inputName
      }

      return `${this.entityName}[${snakeCase(this.type)}_name]`
    },

    label() {
      return this.labelOverride || this.i18n.t(`simple_form.labels.defaults.${this.type}_name`)
    }
  }
}
</script>
